// @flow

import React, { Component } from 'react';
import { observer } from 'mobx-react';

import { jobs as t } from 'helpers/translation';
import { links } from 'core/config/index';
import BtnXs from 'components/BtnXs';
import { LIKEABLE_TYPE_JOB, LIKEABLE_TYPE_COMPANY } from 'core/constants/likes';

type Props = {
  id: number | string,
  user: any,
  isCurrentUser: boolean,
  handleLike: Function,
  type: LIKEABLE_TYPE_JOB | LIKEABLE_TYPE_COMPANY
};

@observer
class Like extends Component<Props> {
  render() {
    const { id, user, isCurrentUser, handleLike, type } = this.props;
    const likedBtn = isCurrentUser && user.likes.find(({ likeableId }) => likeableId === +id);

    const btnProps = {
      [LIKEABLE_TYPE_JOB]: likedBtn ?
        {
          type: 'saved',
          text: t.btn.saved_job,
          id: likedBtn.id,
          classes: 'btn_bookmarked'
        } : {
          type: 'secondary',
          text: t.btn.save_job,
          id: null,
          classes: 'btn_bookmark'
        },
      [LIKEABLE_TYPE_COMPANY]: likedBtn ?
        {
          type: 'saved',
          text: t.btn.following,
          id: likedBtn.id,
          classes: 'btn_check'
        } : {
          type: 'secondary',
          text: t.btn.follow,
          id: null,
          classes: 'btn_add'
        }
    };

    const onLike = e => {
      const data = {
        likeableId: id,
        likeableType: type,
        user: { id: user.id },
        likeId: e.target.getAttribute('id')
      };

      if (isCurrentUser) handleLike(data);
    };

    return (
      <BtnXs
        { ...btnProps[type] }
        handleClick={e => onLike(e)}
        href={!isCurrentUser ? links.login : ''}
      />
    );
  }
}

export default Like;
